import { STATIC_HM_PATH } from "@project/shared-types";
import { Link } from "../../../components/link/link";
import { Text } from "../../../components/texts/text";
import { _sizeText } from "../../../core/core";
import "./ItemGroupService.css";
interface ItemGroupServiceProps {
  title: string;
  image?: string;
  url: string;
  [key: string]: any;
}

export const ItemGroupService: React.FC<ItemGroupServiceProps> = ({
  title,
  image = "card_0",
  url,
  ...props
}) => {
  return (
    <Link link={url} className={"item-group-service "}>
      <img
        className="item-group-img"
        src={`${STATIC_HM_PATH}images/${image}.webp`}
      />
      <Text size={_sizeText.xlb}>{title}</Text>
    </Link>
  );
};
